export const siteInfo = {
  name: "看料档案",
  slogan: "深挖事件 · 起底背后",
  intro:
    "看料档案是一个专注事件深挖的内容门户。我们不追逐第一时间的传闻，而是把散落的信息重新拼回逻辑链条，用档案化的方式梳理每一次公共事件的来龙去脉。",
  email: "contact@kanliao-archive.example",
  since: "2021",
  stats: [
    { label: "已归档专题", value: "1286", unit: "篇" },
    { label: "活跃读者", value: "42.7", unit: "万" },
    { label: "深度栏目", value: "3", unit: "个" },
    { label: "平均阅读时长", value: "9.4", unit: "分钟" },
  ],
  principles: [
    {
      icon: "ri-stack-line",
      title: "只做结构化梳理",
      desc: "把零散信息按时间线、利益链与关键节点重新排列，让读者一眼看清事件骨架。",
    },
    {
      icon: "ri-shield-check-line",
      title: "标注信息出处等级",
      desc: "公开信息、二手转述与待核实内容分开标记，不把推测写成结论。",
    },
    {
      icon: "ri-scales-3-line",
      title: "多角度交叉比对",
      desc: "同一件事至少呈现两方以上的叙述视角，避免单一信源造成的偏差。",
    },
    {
      icon: "ri-refresh-line",
      title: "持续修订与更新",
      desc: "事件有后续，档案就跟着更新，并保留每一次修订的记录。",
    },
  ],
};

export const readerVoices = [
  {
    name: "沈柏舟",
    role: "内容从业者",
    text: "别的号追热点只给结论，看料档案会把时间线一层层摊开，看完自己就能判断，这种阅读体验很难得。",
  },
  {
    name: "梁絮",
    role: "产品经理",
    text: "做行业研究时我常翻这里的行业内幕栏目，它把商业动作背后的动机讲得很清楚，不是空喊内幕。",
  },
  {
    name: "赵既明",
    role: "高校教师",
    text: "最欣赏的是它标注了信息可信度等级。作为教学素材，这种「不把猜测当事实」的态度特别重要。",
  },
  {
    name: "吴向晚",
    role: "自由撰稿人",
    text: "舆情深挖那个栏目帮我理清了好几次公共讨论的发酵路径，写稿时直接拿来做参照框架。",
  },
];